/** Browser-side iOS detection.
 *
 *  Used by the auth landing pages (MagicLinkConsumePage,
 *  ClaimSignupPage) to render an "Open in PencilOut app" chooser
 *  for users tapping email links from Mail.app on iOS, while
 *  still letting them stay on the web if they prefer.
 *
 *  iPadOS 13+ identifies as Mac in the user agent, so we also
 *  check touch + maxTouchPoints to catch that case.
 */
export function detectIOS(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  if (/iPhone|iPod/.test(ua)) return true;
  if (/iPad/.test(ua)) return true;
  if (
    /Macintosh/.test(ua) &&
    typeof navigator.maxTouchPoints === "number" &&
    navigator.maxTouchPoints > 1
  ) {
    return true;
  }
  return false;
}
